import 'whatwg-fetch'

import { isServer } from '@mr-yum/frontend-core/dist/support/env'
import FlagProvider, {
  IConfig,
  useUnleashContext,
} from '@unleash/proxy-client-react'
import { releaseStage } from 'lib/config'
import { useCurrentUserQuery } from 'lib/gql'
import { observer } from 'mobx-react-lite'
import getConfig from 'next/config'
import React, { useContext, useEffect } from 'react'
import { CustomerStoreContext } from 'stores/CustomerStore'
import { InMemoryStorageProvider, UnleashClient } from 'unleash-proxy-client'

const { publicRuntimeConfig } = getConfig()
const { REGION } = publicRuntimeConfig

export const UNLEASH_CONFIG: IConfig = {
  url: 'https://app.unleash-hosted.com/euaa002/api/proxy',
  clientKey: 'd14e2618cad473a8f23e328',
  appName: 'default',
  environment: releaseStage,
}

const UpdateContext: React.FC<{
  venueSlug: string | null
  region: string | null
}> = observer(({ venueSlug, region }) => {
  const { sessionId } = useContext(CustomerStoreContext)
  const [{ data }] = useCurrentUserQuery({
    pause: isServer,
  })
  const updateContext = useUnleashContext()
  const userId = data?.currentUser?.id

  useEffect(() => {
    if (venueSlug) {
      updateContext({
        sessionId,
        userId,
        properties: {
          venueSlug,
          ...(region ? { region } : {}),
        },
      })
    }
  }, [updateContext, venueSlug, region, sessionId, userId])

  return null
})

export const UnleashContextProvider: React.FC<{ venueSlug: string | null }> =
  observer(({ children, venueSlug }) => {
    const ssrOption =
      typeof window !== 'undefined'
        ? {}
        : { fetch: fetch, storageProvider: new InMemoryStorageProvider() }

    const client = new UnleashClient({
      ...UNLEASH_CONFIG,
      ...ssrOption,
      context: {
        properties: {
          // region specifies the frontend server region, not necessarily the venue region
          ...(REGION ? { region: REGION } : {}),
        },
      },
    })

    return (
      <FlagProvider unleashClient={client}>
        <UpdateContext venueSlug={venueSlug} region={REGION} />
        {children}
      </FlagProvider>
    )
  })
